import React from 'react';

import { useParams } from 'react-router-dom';

import { propertyFacilityAssociationConfig } from '~/components/Accommodation/configs/facilityAssociationConfig';

import CatalogItemAssociationGrid from '../CatalogItemAssociationGrid';

export default function AccommodationPropertyFacilitiesSection() {
  const { propertyId } = useParams<{ propertyId: string }>();

  if (!propertyId) {
    return null;
  }

  return <CatalogItemAssociationGrid config={propertyFacilityAssociationConfig} pathParams={{ propertyId }} />;
}
